import { createSlice } from '@reduxjs/toolkit'
import { AxiosError } from '@src/helpers/httpClient'

import {
  ASSESSMENT_OFFENCE,
  ASSESSMENT_OFFENCE_ALL,
  ASSESSMENT_OFFENCE_CHANGE_STATUS,
  ASSESSMENT_OFFENCE_CHANGE_SUBJECT_BOARD_STATUS,
  ASSESSMENT_OFFENCE_INVIGILATION,
  ASSESSMENT_OFFENCE_INVIGILATION_ALL,
  ASSESSMENT_OFFENCE_INVIGILATION_CONSULTATIONS,
  ASSESSMENT_OFFENCE_INVIGILATION_CONSULTATIONS_ALL,
  ASSESSMENT_OFFENCE_INVIGILATION_MINUTES,
  ASSESSMENT_OFFENCE_INVIGILATION_MINUTES_ALL,
  ASSESSMENT_OFFENCE_REPORT_ALL,
  ASSESSMENT_OFFENCE_REPORT_CREATE,
  ASSESSMENT_OFFENCE_REPORT_LIST,
  ASSESSMENT_OFFENCE_TYPE,
  ASSESSMENT_OFFENCE_TYPE_ALL,
  GLOBAL_STATE,
  OFFENCE_UPDATED,
  OFFENCE_UPDATED_BY_ID,
  REPORT_MISCONDUCT,
} from '../constants/actionTypes'
import * as actionCreators from './actions'
import { defaultState, initialState } from './initialState'

export const ACADEMIC_MISCONDUCT = GLOBAL_STATE

const academicMisconductSlice = createSlice({
  name: ACADEMIC_MISCONDUCT,
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(actionCreators.assessmentOffence.pending, state => {
        state[ASSESSMENT_OFFENCE].loading = true
      })
      .addCase(actionCreators.assessmentOffence.rejected, (state, action) => {
        state[ASSESSMENT_OFFENCE].loading = false
        state[ASSESSMENT_OFFENCE].error = action.payload as AxiosError
      })
      .addCase(actionCreators.assessmentOffence.fulfilled, (state, action) => {
        state[ASSESSMENT_OFFENCE].loading = false
        state[ASSESSMENT_OFFENCE].error = null
        state[ASSESSMENT_OFFENCE].data = action.payload
      })

    builder
      .addCase(actionCreators.assessmentOffenceAll.pending, state => {
        state[ASSESSMENT_OFFENCE_ALL].loading = true
      })
      .addCase(actionCreators.assessmentOffenceAll.rejected, (state, action) => {
        state[ASSESSMENT_OFFENCE_ALL].loading = false
        state[ASSESSMENT_OFFENCE_ALL].error = action.payload as AxiosError
      })
      .addCase(actionCreators.assessmentOffenceAll.fulfilled, (state, action) => {
        state[ASSESSMENT_OFFENCE_ALL].loading = false
        state[ASSESSMENT_OFFENCE_ALL].error = null
        state[ASSESSMENT_OFFENCE_ALL].data = action.payload
      })

    builder
      .addCase(actionCreators.assessmentOffenceChangeStatus.pending, state => {
        state[ASSESSMENT_OFFENCE_CHANGE_STATUS].loading = true
      })
      .addCase(actionCreators.assessmentOffenceChangeStatus.rejected, (state, action) => {
        state[ASSESSMENT_OFFENCE_CHANGE_STATUS].loading = false
        state[ASSESSMENT_OFFENCE_CHANGE_STATUS].error = action.payload as AxiosError
      })
      .addCase(actionCreators.assessmentOffenceChangeStatus.fulfilled, (state, action) => {
        state[ASSESSMENT_OFFENCE_CHANGE_STATUS].loading = false
        state[ASSESSMENT_OFFENCE_CHANGE_STATUS].error = null
        state[ASSESSMENT_OFFENCE_CHANGE_STATUS].data = action.payload
      })

    builder
      .addCase(actionCreators.assessmentOffenceSubjectBoardStatusChange.pending, state => {
        state[ASSESSMENT_OFFENCE_CHANGE_SUBJECT_BOARD_STATUS].loading = true
      })
      .addCase(actionCreators.assessmentOffenceSubjectBoardStatusChange.rejected, (state, action) => {
        state[ASSESSMENT_OFFENCE_CHANGE_SUBJECT_BOARD_STATUS].loading = false
        state[ASSESSMENT_OFFENCE_CHANGE_SUBJECT_BOARD_STATUS].error = action.payload as AxiosError
      })
      .addCase(actionCreators.assessmentOffenceSubjectBoardStatusChange.fulfilled, (state, action) => {
        state[ASSESSMENT_OFFENCE_CHANGE_SUBJECT_BOARD_STATUS].loading = false
        state[ASSESSMENT_OFFENCE_CHANGE_SUBJECT_BOARD_STATUS].error = null
        state[ASSESSMENT_OFFENCE_CHANGE_SUBJECT_BOARD_STATUS].data = action.payload
      })

    builder
      .addCase(actionCreators.assessmentOffenceInvigilation.pending, state => {
        state[ASSESSMENT_OFFENCE_INVIGILATION].loading = true
      })
      .addCase(actionCreators.assessmentOffenceInvigilation.rejected, (state, action) => {
        state[ASSESSMENT_OFFENCE_INVIGILATION].loading = false
        state[ASSESSMENT_OFFENCE_INVIGILATION].error = action.payload as AxiosError
      })
      .addCase(actionCreators.assessmentOffenceInvigilation.fulfilled, (state, action) => {
        state[ASSESSMENT_OFFENCE_INVIGILATION].loading = false
        state[ASSESSMENT_OFFENCE_INVIGILATION].error = null
        state[ASSESSMENT_OFFENCE_INVIGILATION].data = action.payload
      })

    builder
      .addCase(actionCreators.assessmentOffenceInvigilationAll.pending, state => {
        state[ASSESSMENT_OFFENCE_INVIGILATION_ALL].loading = true
      })
      .addCase(actionCreators.assessmentOffenceInvigilationAll.rejected, (state, action) => {
        state[ASSESSMENT_OFFENCE_INVIGILATION_ALL].loading = false
        state[ASSESSMENT_OFFENCE_INVIGILATION_ALL].error = action.payload as AxiosError
      })
      .addCase(actionCreators.assessmentOffenceInvigilationAll.fulfilled, (state, action) => {
        state[ASSESSMENT_OFFENCE_INVIGILATION_ALL].loading = false
        state[ASSESSMENT_OFFENCE_INVIGILATION_ALL].error = null
        state[ASSESSMENT_OFFENCE_INVIGILATION_ALL].data = action.payload
      })

    builder
      .addCase(actionCreators.assessmentOffenceInvigilationConsultations.pending, state => {
        state[ASSESSMENT_OFFENCE_INVIGILATION_CONSULTATIONS].loading = true
      })
      .addCase(actionCreators.assessmentOffenceInvigilationConsultations.rejected, (state, action) => {
        state[ASSESSMENT_OFFENCE_INVIGILATION_CONSULTATIONS].loading = false
        state[ASSESSMENT_OFFENCE_INVIGILATION_CONSULTATIONS].error = action.payload as AxiosError
      })
      .addCase(actionCreators.assessmentOffenceInvigilationConsultations.fulfilled, (state, action) => {
        state[ASSESSMENT_OFFENCE_INVIGILATION_CONSULTATIONS].loading = false
        state[ASSESSMENT_OFFENCE_INVIGILATION_CONSULTATIONS].error = null
        state[ASSESSMENT_OFFENCE_INVIGILATION_CONSULTATIONS].data = action.payload
      })

    builder
      .addCase(actionCreators.assessmentOffenceInvigilationConsultationsAll.pending, state => {
        state[ASSESSMENT_OFFENCE_INVIGILATION_CONSULTATIONS_ALL].loading = true
      })
      .addCase(actionCreators.assessmentOffenceInvigilationConsultationsAll.rejected, (state, action) => {
        state[ASSESSMENT_OFFENCE_INVIGILATION_CONSULTATIONS_ALL].loading = false
        state[ASSESSMENT_OFFENCE_INVIGILATION_CONSULTATIONS_ALL].error = action.payload as AxiosError
      })
      .addCase(actionCreators.assessmentOffenceInvigilationConsultationsAll.fulfilled, (state, action) => {
        state[ASSESSMENT_OFFENCE_INVIGILATION_CONSULTATIONS_ALL].loading = false
        state[ASSESSMENT_OFFENCE_INVIGILATION_CONSULTATIONS_ALL].error = null
        state[ASSESSMENT_OFFENCE_INVIGILATION_CONSULTATIONS_ALL].data = action.payload
      })

    builder
      .addCase(actionCreators.assessmentOffenceInvigilationMinutes.pending, state => {
        state[ASSESSMENT_OFFENCE_INVIGILATION_MINUTES].loading = true
      })
      .addCase(actionCreators.assessmentOffenceInvigilationMinutes.rejected, (state, action) => {
        state[ASSESSMENT_OFFENCE_INVIGILATION_MINUTES].loading = false
        state[ASSESSMENT_OFFENCE_INVIGILATION_MINUTES].error = action.payload as AxiosError
      })
      .addCase(actionCreators.assessmentOffenceInvigilationMinutes.fulfilled, (state, action) => {
        state[ASSESSMENT_OFFENCE_INVIGILATION_MINUTES].loading = false
        state[ASSESSMENT_OFFENCE_INVIGILATION_MINUTES].error = null
        state[ASSESSMENT_OFFENCE_INVIGILATION_MINUTES].data = action.payload
      })

    builder
      .addCase(actionCreators.assessmentOffenceInvigilationMinutesAll.pending, state => {
        state[ASSESSMENT_OFFENCE_INVIGILATION_MINUTES_ALL].loading = true
      })
      .addCase(actionCreators.assessmentOffenceInvigilationMinutesAll.rejected, (state, action) => {
        state[ASSESSMENT_OFFENCE_INVIGILATION_MINUTES_ALL].loading = false
        state[ASSESSMENT_OFFENCE_INVIGILATION_MINUTES_ALL].error = action.payload as AxiosError
      })
      .addCase(actionCreators.assessmentOffenceInvigilationMinutesAll.fulfilled, (state, action) => {
        state[ASSESSMENT_OFFENCE_INVIGILATION_MINUTES_ALL].loading = false
        state[ASSESSMENT_OFFENCE_INVIGILATION_MINUTES_ALL].error = null
        state[ASSESSMENT_OFFENCE_INVIGILATION_MINUTES_ALL].data = action.payload
      })

    builder
      .addCase(actionCreators.assessmentOffenceReportAll.pending, state => {
        state[ASSESSMENT_OFFENCE_REPORT_ALL].loading = true
      })
      .addCase(actionCreators.assessmentOffenceReportAll.rejected, (state, action) => {
        state[ASSESSMENT_OFFENCE_REPORT_ALL].loading = false
        state[ASSESSMENT_OFFENCE_REPORT_ALL].error = action.payload as AxiosError
      })
      .addCase(actionCreators.assessmentOffenceReportAll.fulfilled, (state, action) => {
        state[ASSESSMENT_OFFENCE_REPORT_ALL].loading = false
        state[ASSESSMENT_OFFENCE_REPORT_ALL].error = null
        state[ASSESSMENT_OFFENCE_REPORT_ALL].data = action.payload
      })

    builder
      .addCase(actionCreators.assessmentOffenceReportCreate.pending, state => {
        state[ASSESSMENT_OFFENCE_REPORT_CREATE].loading = true
      })
      .addCase(actionCreators.assessmentOffenceReportCreate.rejected, (state, action) => {
        state[ASSESSMENT_OFFENCE_REPORT_CREATE].loading = false
        state[ASSESSMENT_OFFENCE_REPORT_CREATE].error = action.payload as AxiosError
      })
      .addCase(actionCreators.assessmentOffenceReportCreate.fulfilled, (state, action) => {
        state[ASSESSMENT_OFFENCE_REPORT_CREATE].loading = false
        state[ASSESSMENT_OFFENCE_REPORT_CREATE].error = null
        state[ASSESSMENT_OFFENCE_REPORT_CREATE].data = action.payload
      })

    builder
      .addCase(actionCreators.assessmentOffenceReportList.pending, state => {
        state[ASSESSMENT_OFFENCE_REPORT_LIST].loading = true
      })
      .addCase(actionCreators.assessmentOffenceReportList.rejected, (state, action) => {
        state[ASSESSMENT_OFFENCE_REPORT_LIST].loading = false
        state[ASSESSMENT_OFFENCE_REPORT_LIST].error = action.payload as AxiosError
      })
      .addCase(actionCreators.assessmentOffenceReportList.fulfilled, (state, action) => {
        state[ASSESSMENT_OFFENCE_REPORT_LIST].loading = false
        state[ASSESSMENT_OFFENCE_REPORT_LIST].error = null
        state[ASSESSMENT_OFFENCE_REPORT_LIST].data = action.payload
      })

    builder
      .addCase(actionCreators.assessmentOffenceType.pending, state => {
        state[ASSESSMENT_OFFENCE_TYPE].loading = true
      })
      .addCase(actionCreators.assessmentOffenceType.rejected, (state, action) => {
        state[ASSESSMENT_OFFENCE_TYPE].loading = false
        state[ASSESSMENT_OFFENCE_TYPE].error = action.payload as AxiosError
      })
      .addCase(actionCreators.assessmentOffenceType.fulfilled, (state, action) => {
        state[ASSESSMENT_OFFENCE_TYPE].loading = false
        state[ASSESSMENT_OFFENCE_TYPE].error = null
        state[ASSESSMENT_OFFENCE_TYPE].data = action.payload
      })

    builder
      .addCase(actionCreators.assessmentOffenceTypeAll.pending, state => {
        state[ASSESSMENT_OFFENCE_TYPE_ALL].loading = true
      })
      .addCase(actionCreators.assessmentOffenceTypeAll.rejected, (state, action) => {
        state[ASSESSMENT_OFFENCE_TYPE_ALL].loading = false
        state[ASSESSMENT_OFFENCE_TYPE_ALL].error = action.payload as AxiosError
      })
      .addCase(actionCreators.assessmentOffenceTypeAll.fulfilled, (state, action) => {
        state[ASSESSMENT_OFFENCE_TYPE_ALL].loading = false
        state[ASSESSMENT_OFFENCE_TYPE_ALL].error = null
        state[ASSESSMENT_OFFENCE_TYPE_ALL].data = action.payload
      })

    builder
      .addCase(actionCreators.reportMisconduct.pending, state => {
        state[REPORT_MISCONDUCT].loading = true
      })
      .addCase(actionCreators.reportMisconduct.rejected, (state, action) => {
        state[REPORT_MISCONDUCT].loading = false
        state[REPORT_MISCONDUCT].error = action.payload as AxiosError
      })
      .addCase(actionCreators.reportMisconduct.fulfilled, (state, action) => {
        state[REPORT_MISCONDUCT].loading = false
        state[REPORT_MISCONDUCT].error = null
        state[REPORT_MISCONDUCT].data = action.payload
      })

    builder
      .addCase(actionCreators.offenceUpdated.pending, state => {
        state[OFFENCE_UPDATED].loading = true
      })
      .addCase(actionCreators.offenceUpdated.rejected, (state, action) => {
        state[OFFENCE_UPDATED].loading = false
        state[OFFENCE_UPDATED].error = action.payload as AxiosError
      })
      .addCase(actionCreators.offenceUpdated.fulfilled, (state, action) => {
        state[OFFENCE_UPDATED].loading = false
        state[OFFENCE_UPDATED].error = null
        state[OFFENCE_UPDATED].data = action.payload
      })

    builder
      .addCase(actionCreators.offenceUpdatedById.pending, state => {
        state[OFFENCE_UPDATED_BY_ID].loading = true
      })
      .addCase(actionCreators.offenceUpdatedById.rejected, (state, action) => {
        state[OFFENCE_UPDATED_BY_ID].loading = false
        state[OFFENCE_UPDATED_BY_ID].error = action.payload as AxiosError
      })
      .addCase(actionCreators.offenceUpdatedById.fulfilled, (state, action) => {
        state[OFFENCE_UPDATED_BY_ID].loading = false
        state[OFFENCE_UPDATED_BY_ID].error = null
        state[OFFENCE_UPDATED_BY_ID].data = action.payload
      })

    builder.addCase(actionCreators.assessmentOffenceClear, state => {
      state[ASSESSMENT_OFFENCE] = defaultState()
    })

    builder.addCase(actionCreators.assessmentOffenceAllClear, state => {
      state[ASSESSMENT_OFFENCE_ALL] = defaultState()
    })

    builder.addCase(actionCreators.assessmentOffenceInvigilationClear, state => {
      state[ASSESSMENT_OFFENCE_INVIGILATION] = defaultState()
    })

    builder.addCase(actionCreators.assessmentOffenceInvigilationAllClear, state => {
      state[ASSESSMENT_OFFENCE_INVIGILATION_ALL] = defaultState()
    })

    builder.addCase(actionCreators.assessmentOffenceInvigilationConsultationsClear, state => {
      state[ASSESSMENT_OFFENCE_INVIGILATION_CONSULTATIONS] = defaultState()
    })

    builder.addCase(actionCreators.assessmentOffenceInvigilationConsultationsAllClear, state => {
      state[ASSESSMENT_OFFENCE_INVIGILATION_CONSULTATIONS_ALL] = defaultState()
    })

    builder.addCase(actionCreators.assessmentOffenceInvigilationMinutesAllClear, state => {
      state[ASSESSMENT_OFFENCE_INVIGILATION_MINUTES_ALL] = defaultState()
    })

    builder.addCase(actionCreators.assessmentOffenceTypeAllClear, state => {
      state[ASSESSMENT_OFFENCE_TYPE_ALL] = defaultState()
    })

    builder.addCase(actionCreators.offenceUpdatedClear, state => {
      state[OFFENCE_UPDATED] = defaultState()
    })

    builder.addCase(actionCreators.offenceUpdatedByIdClear, state => {
      state[OFFENCE_UPDATED_BY_ID] = defaultState()
    })
  },
})

export const { reducer: academicMisconductReducer } = academicMisconductSlice
